export default __webpack_public_path__ + "static/media/warehouse_managemnt_orange.bb5fc746.svg";